module.exports = __webpack_public_path__ + "img/home_img2.5edc61b4.png";